import { getQueryParams } from '../routing/getQueryParams';
export const useUpdatedBranding = () => {
  var _queryParams$flags;
  const queryParams = getQueryParams();
  const isFromDotCom = 'hubs_content' in queryParams && Boolean(queryParams['hubs_content']) || 'hubs_signup-url' in queryParams && Boolean(queryParams['hubs_signup-url']);
  const isUngatedByFlag = 'flags' in queryParams && ((_queryParams$flags = queryParams['flags']) === null || _queryParams$flags === void 0 ? void 0 : _queryParams$flags.includes('INBOUND_25_FLAG'));
  const useBranding = isFromDotCom && isUngatedByFlag;
  return useBranding;
};